



















import Vue from 'vue'
import MemoInputAndButton from '@/dome/components/DomeTransactionalInfo/MemoInputAndButton.vue'
import { mapActions, mapGetters } from 'vuex'
import { FraudTransactionActions, FraudTransactionGetters } from '@/dome/store/fraudTransactionState'
import { IMemoLine } from '@/dome/types/IMemoTimeLine'
import DomeMemoLine from '@/dome/container/DomeTransactionalInfo/DomeMemoLine.vue'
import { IFraudTimeLine } from '@/dome/types/FraudTypes'
import dayjs from 'dayjs'

export default Vue.extend({
  components: { MemoInputAndButton, DomeMemoLine },
  data(): {
    memoLineList: Array<IMemoLine>
  } {
    return {
      memoLineList: []
    }
  },
  computed: {
    ...mapGetters('fraudTransactionState', {
      fraudTransactionDetail: FraudTransactionGetters.FraudTransactionDetail
    })
  },
  created: async function () {
    await this.setMemoLineList()
  },
  methods: {
    ...mapActions('fraudTransactionState', {
      postFraudTransactionMemo: FraudTransactionActions.PostFraudTransactionMemo
    }),
    async onMemoInputted(input: string): Promise<void> {
      await this.postMemo(input)
    },
    async postMemo(input: string): Promise<void> {
      await this.postFraudTransactionMemo({
        payment_id: this.fraudTransactionDetail.id,
        writer: localStorage.getItem('email'),
        content: input
      })
      await this.setMemoLineList()
    },
    async setMemoLineList(): Promise<void> {
      this.memoLineList = []
      this.memoLineList = this.convertTimeLinesToList(this.fraudTransactionDetail.fraud_timeline)
    },
    convertTimeLinesToList(timeLines: Array<IFraudTimeLine>): Array<IMemoLine> {
      return timeLines.map(timeLine => {
        return {
          id: timeLine.id,
          created_at: dayjs(timeLine.created_at).format('YYYY-MM-DD'),
          action: timeLine.action,
          content: timeLine.param.content,
          writer: timeLine.param.writer
        }
      })
    }
  }
})
